import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
    isSidebarCollapsed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    openImpersonationModal$: Subject<void> = new Subject<void>();

    toggleSidebar(): void {
        this.isSidebarCollapsed$.next(!this.isSidebarCollapsed$.value);
    }

    openImpersonationModal(): void {
        this.openImpersonationModal$.next();
    }
}
